export default (value) => {
  if (!value && value !== 0) return value;

  const formattedValue = value.toFixed(2);
  return formattedValue.endsWith('.00') ? `${Math.trunc(value)}` : formattedValue.replace('.', ',');
};
